export default __webpack_public_path__ + "static/media/ibobby_refund.0eab211a.png";